import React from 'react'
import spinner from '../assets/spinner.gif'
const Spinner = () => {
    return (
        <div>
            <img src={spinner} height="120rem" />
        </div>
    )
}

export default Spinner
